import * as React from 'react';
import { useSelector } from 'react-redux';

import { Address } from '../../components/Address';
import { getFullAddress } from '../../selectors/newbuilding';
import { MapPreviewContainer } from '../MapPreview';
import { RoadsContainer } from '../Roads';
import { TransportAccessibilityEntryContainer } from '../TransportAccessibilityEntry';
import { UndergroundContainer } from '../Underground';

export function AddressContainer() {
  const fullAddress = useSelector(getFullAddress);

  return (
    <Address
      fullAddress={fullAddress}
      mapPreview={<MapPreviewContainer />}
      underground={<UndergroundContainer />}
      roads={<RoadsContainer />}
      transportAccessibility={<TransportAccessibilityEntryContainer />}
    />
  );
}
